import { RESET_AUTH_EMAILS_FORM } from '../actionTypes';
import { actions } from '../reducer';

export default () => actions[RESET_AUTH_EMAILS_FORM]();
